import React from 'react';
import { Helmet } from 'react-helmet';
import { useBrandContext } from '../../context/BrandContext';

const Favicon: React.FC = () => {
  const brandContext = useBrandContext();

  const getFaviconPath = () => {
    return `/assets/favicons/${brandContext.brandName}.ico`;
  };

  return (
    <Helmet>
      <link rel='icon' href={getFaviconPath()} />
      <link rel='shortcut icon' href={getFaviconPath()} />
    </Helmet>
  );
};

export default Favicon;
